<script>
// import ReportCard from '@/views/live/components/ReportCard'
import { breadcrumbEventBus } from '@/main'
import LiveReportService from '@/services/ReportModules/LiveReportService'

export default {
  created () {
    this.location_id = this.$route.params.location_id
  },
  data () {
    return {
      exceptions: {},
      hasSchedule: false,
      cards: [
        {
          title: 'Clocked In',
          element: 'clockedin',
          schedulerequired: false,
          expanded: true,
          columns: {
            headers: ['Employee', 'Started', 'Hours'],
            align: ['left', 'left', 'right'],
            values: []
          },
          data: []
        },
        {
          title: 'Clocked Out',
          element: 'clockedout',
          schedulerequired: false,
          expanded: true,
          columns: {
            headers: ['Employee', 'Start/End', 'Hours'],
            align: ['left', 'left', 'right'],
            values: []
          },
          data: []
        },
        {
          title: 'No Show',
          element: 'noshow',
          schedulerequired: true,
          expanded: true,
          columns: {
            headers: ['Employee', 'Schd. Start/End', 'Schd. Hours'],
            align: ['left', 'left', 'right'],
            values: []
          },
          data: []
        },
        {
          title: 'Upcoming',
          element: 'upcoming',
          schedulerequired: true,
          expanded: true,
          columns: {
            headers: ['Employee', 'Schd. Start/End', 'Schd. Hours'],
            align: ['left', 'left', 'right'],
            values: []
          },
          data: []
        }
      ],
      location: {
        timeoff: [],
        updated: {}
      },
      laborSummary: {},
      timeoff: [],
      timeoffexpanded: true
    }
  },
  mounted () {
    this.$updateloading(2)
    LiveReportService.getLocationLabor(this.location_id).then(data => {
      this.exceptions = data.exceptions
      this.cards.forEach(function (card) {
        card.data = data[card.element]
      })
      this.hasSchedule = data.hasSchedule
      this.timeoff = data.timeoff

      console.log(this.exceptions)
      this.$updateloading(-1)
    })
    LiveReportService.getLocation(this.location_id).then(data => {
      this.location = data
      this.setBreadcrumb()
      this.$updateloading(-1)
    })
  },
  methods: {
    setBreadcrumb: function () {
      const breadcrumb = []
      breadcrumb.push({ link: '/live/home', title: 'Home' })
      breadcrumb.push({
        link: '/live/location/' + this.location_id,
        title: this.location.name
      })
      breadcrumb.push({ link: null, title: 'Labor' })
      breadcrumbEventBus.$emit('breadcrumbChanged', breadcrumb)
    },
    getTextAlign: function (column) {
      // basing on each 'column' object from prop
      // set the text align css basing on column.textAlign property
      // we can set left,centr, right. There is default which is center
      const textAlign = column
      if (!textAlign) {
        return 'text-left'
      }
      switch (textAlign) {
        case 'left':
          return 'text-left'
        case 'right':
          return 'text-right'
        case 'center':
          return 'text-center'
      }
    }
  },
  components: {
    //  ReportCard
  }
}
</script>

<template>
  <div>
    <div class="row">
      <div class="col-sm-12 col-lg-4">
        <div class="updated">Updated: {{location.updated.lastupdate}}</div>
      </div>
    </div>

    <div class="row">
      <div
        class="col-sm-12 col-lg-4"
        v-for="(c, ci) in cards"
        :key="ci"
        v-show="(hasSchedule && c.schedulerequired) || !c.schedulerequired"
      >
        <div class>
          <div class="list-group">
            <div class="list-group-item active">
              <div class="list-group-item-heading float-left">
                <strong>{{ c.title }}</strong>
              </div>
              <div class="list-group-item-heading float-right">
                <a href="javascript:void(0)" v-on:click="c.expanded = !c.expanded">
                  <i class="fas fa-minus-square" v-show="c.expanded"></i>
                  <i class="fas fa-plus-square" v-show="!c.expanded"></i>
                </a>
              </div>
            </div>
            <div class="list-group-item" v-show="c.expanded">
              <div class="row">
                <div class="col-sm-12 table-responsive">
                  <table class="table table-condensed employee-labor">
                    <thead>
                      <tr>
                        <th
                          :class="getTextAlign(c.columns.align[ehi])"
                          v-for="(emh,ehi) in c.columns.headers"
                          :key="ehi"
                        >{{emh}}</th>
                        <!-- <th>Employee</th>
                        <th>
                          <span v-if="c.element == 'clockedin'">Start</span>
                          <span v-if="c.element != 'clockedin'">Start/End</span>
                        </th>
                        <th class="text-right">Hours</th>-->
                      </tr>
                    </thead>
                    <tbody v-show="c.data.length > 0" v-for="(em, index) in c.data" :key="index">
                      <tr class="emp" v-if="c.element!='noshow'">
                        <td>
                          {{ em.employeename }}
                          <br />
                          <small>{{ em.jobtype }}</small>
                        </td>
                        <td>
                          {{ em.starttimef }}
                          <span v-if="c.element == 'clockedin'">- Current</span>
                          <span v-if="c.element != 'clockedin'">- {{ em.endtimef }}</span>
                        </td>
                        <td class="text-right">{{ em.hours | number('0.00') }}</td>
                        <!-- |<span :key="eindex" v-for="(ex, eindex) in em.exceptions">{{ex.type}}|</span> -->
                      </tr>
                      <tr
                        v-if="em.exceptions.length > 0 && c.element!='noshow' && hasSchedule"
                        class="exception-row"
                      >
                        <td colspan="3">
                          <table class="table table-condensed exception table-borderless">
                            <tbody>
                              <tr
                                v-for="(ex, exi) in em.exceptions"
                                :key="exi"
                                v-show="(c.element != 'clockedin') || (c.element == 'clockedin' && ex.id != 30 && ex.id != 40)"
                              >
                                <td style="width:30%">
                                  <small>{{ ex.type }}</small>
                                </td>
                                <td>
                                  <small
                                    v-for="(ev,evi) in exceptions[ex.id].columns.values"
                                    :key="evi"
                                    v-show="(c.element != 'clockedin') || (exceptions[ex.id].columns.headers[evi] != 'Clock-Out' && c.element == 'clockedin')"
                                  >
                                    {{exceptions[ex.id].columns.headers_mobile[evi]}}:
                                    {{ex.timeclock[exceptions[ex.id].columns.values[evi]]}}
                                    {{exceptions[ex.id].columns.units[evi]}}
                                    &nbsp;&nbsp;
                                  </small>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </td>
                      </tr>
                      <tr
                        v-if="em.exceptions.length > 0 && c.element == 'noshow'"
                      >
                        <td>
                          {{ em.lastname }}, {{ em.firstname }}
                          <br />
                          <small>{{ em.jobtype }}</small>
                        </td>
                        <td>{{em.exceptions[0].timeclock.scheduledstarttime}} - {{em.exceptions[0].timeclock.scheduledendtime}}</td>
                        <td class="text-right">{{em.exceptions[0].timeclock.scheduledhours | number('0.00')}}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-xs-12 col-lg-4">
        <div class="well">
          <div class="list-group">
            <div class="list-group-item active">
              <span class="list-group-item-heading">Time Off</span>
              <div class="list-group-item-heading float-right">
                <a
                  href="javascript:void(0)"
                  v-on:click="timeoffexpanded = !timeoffexpanded"
                >
                  <i class="fas fa-minus-square" v-show="timeoffexpanded"></i>
                  <i class="fas fa-plus-square" v-show="!timeoffexpanded"></i>
                </a>
              </div>
            </div>
            <div class="list-group-item" v-show="timeoffexpanded">
              <div class="row">
                <div class="col-sm-12 table-responsive">
                  <table class="table table-condensed">
                    <thead>
                      <tr>
                        <th>Employee</th>
                        <th>Type</th>
                        <th>Time</th>
                        <th>Jobs</th>
                      </tr>
                    </thead>
                    <tbody v-if="timeoff.length > 0">
                      <tr v-for="(to, index) in timeoff" :key="index">
                        <td>{{ to.firstname }} {{ to.lastname }}</td>
                        <td>{{ to.timeofftype }}</td>
                        <td>{{ to.starttimef }} to {{ to.endtimef }}</td>
                        <td>{{ to.jobs }}</td>
                      </tr>
                    </tbody>
                    <tbody v-if="timeoff.length == 0">
                      <tr>
                        <td colspan="4" class="text-center">No Current Timoff Requests</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style  scoped>
.exception tr td {
  border-bottom-width: 1px!important;
}
.exception td:first-child,
tr.table-warning td:first-child,tr.table-warning td:first-child {
  color: #ff0000;
  padding-left:1rem;
}
.exception tr:first-child td {
border-top-width:0px!important;
}
table.exception thead th {
  border-bottom-width: 1px;
}
tr.exception-row>td{
border-color: #696969;
}
table.exception th,
table.exception td {
  padding: 0.1rem;
}
table.exception tr:last-child td {
  border-bottom: 0px solid #dee2e6 !important;
  border-top: 0px solid #dee2e6 !important;
}

table.exception {
  margin: 0;
}
.updated {
  padding: 0.25rem 0.5rem !important;
  margin-bottom: 0.25rem;
  color: #ffffff;
  font-weight: bold;
  /* list-style: none;
  background-color: #e9ecef;
  border-radius: 0.25rem; */
}
tr.exception-row td {
  border-top: 1px solid #dee2e6 !important;
}

</style>
